import appConfig from './apiConfig';

export const fetchDashboardDataApi =(token)=>{

const headers = Object.assign({'content-type':'application/json',
                               'accept':'*/*'
                           });
const request= new Request( appConfig.siteURL+'getDashboardData/'+ token, {
  method : "GET",
  headers : headers,
});

return fetch(request).then(response => {
    return  response.json().then(membersDataResponse => {
      return membersDataResponse;
    });
  }).catch(error => {
   return error;
 });
}



// WEBPACK FOOTER //
// ./src/api/dashboardApi.js